module.exports = __webpack_public_path__ + "media/dogs/ds-app-dog-eating-f1c3b5a5.svg";